import { alpha, type SxProps, type Theme } from '@mui/material/styles';

/** Shared PDL Decision tab radii — shell 22px lives on AmbientGlassShell. */
export const PDL_SECTION_RADIUS = 2;
export const PDL_INNER_RADIUS = 1.5;

export const PDL_CHIP_SX = {
  height: 22,
  fontSize: '0.72rem',
  fontWeight: 700,
} as const;

export const PDL_SECTION_LABEL_SX: SxProps<Theme> = {
  fontWeight: 800,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: 'text.secondary',
  fontSize: '0.68rem',
};

/** Supporting labels in capacity breakdown — readable without squinting. */
export const PDL_SUPPORT_LABEL_SX: SxProps<Theme> = {
  color: 'text.primary',
  opacity: 0.78,
  fontWeight: 600,
  lineHeight: 1.4,
};

/** Soft light-red pulse for decline alerts; static when reduced motion is on. */
export function pdlDeclineAlertPulseSx(theme: Theme): SxProps<Theme> {
  const e = theme.palette.error.main;
  return {
    bgcolor: alpha(e, 0.09),
    border: '1px solid',
    borderColor: alpha(e, 0.34),
    animation: 'pdl-decline-soft-pulse 2.8s ease-in-out infinite',
    '@keyframes pdl-decline-soft-pulse': {
      '0%, 100%': {
        backgroundColor: alpha(e, 0.07),
        borderColor: alpha(e, 0.28),
        boxShadow: `0 0 0 0 ${alpha(e, 0)}`,
      },
      '50%': {
        backgroundColor: alpha(e, 0.15),
        borderColor: alpha(e, 0.5),
        boxShadow: `0 0 0 3px ${alpha(e, 0.1)}`,
      },
    },
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      bgcolor: alpha(e, 0.11),
      borderColor: alpha(e, 0.42),
    },
  };
}
